export const clients = [
  {
    id: 'client-1',
    name: 'Aryan Sharma',
    image: 'https://images.unsplash.com/photo-1600486913747-55e5470d6f40?w=400&h=400&fit=crop&q=80',
    program: 'Elite Performance',
    progress: 78,
    lastActive: '2h ago',
    metrics: {
      recovery: 85,
      strain: 12.4,
      sleep: 92
    }
  },
  {
    id: 'client-2',
    name: 'Mike Johnson',
    image: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=400&h=400&fit=crop&q=80',
    program: 'Strength Builder',
    progress: 65,
    lastActive: '5h ago',
    metrics: {
      recovery: 72,
      strain: 15.8,
      sleep: 84
    }
  },
  {
    id: 'client-3',
    name: 'Emma Wilson',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop&q=80',
    program: 'HIIT Master',
    progress: 92,
    lastActive: '1h ago',
    metrics: {
      recovery: 91,
      strain: 8.5,
      sleep: 95
    }
  }
];